export { PROTOCOL_TYPES, PROTOCOL_INTERVALS } from './Protocol';
export { TREATMENT_STATES, TREATMENT_TYPES, treatment_status, TREATMENT_MODES } from './Treatment';
export { EXPERT_LABELS } from './Expert';
export { DIAGNOSTIC_TYPES, DIAGNOSTIC_INSTRUMENTS } from './Diagnostic';
export { DMT, PSE, PSR, RECOVERY_LABELS, RECOVERY_TYPES } from './Recovery';
export { EXAM_STATISTICS_GRAPH_COLOR, THERAPY_STATISTICS_GRAPH_COLOR, PRIMARY_COLOR, SECONDARY_COLOR } from './colors';
export { CONNECT_FES_CHANNELS } from './Equipments';
export { FAKE_COMPANIONS } from './mocks'
